

export const squareValue = {
  n: 2,
  m: 2
};

export const buttons = [{
  id: '1',
  icon: 'icon_bracketfixing-type-01',
  tooltip:"TT110", //APP_TOOLTIPS.TOOLTIP_ANCHOR.Content,
  count: {
    n: 2,
    m: 1
  }
}, {
  id: '2',
  icon: 'icon_bracketfixing-type-02',
  tooltip:"TT110", //APP_TOOLTIPS.TOOLTIP_ANCHOR.Content,
  count: {
    n: 1,
    m: 2
  }
}, {
  id: '3',
  icon: 'icon_bracketfixing-type-03',
  tooltip:"TT110", //APP_TOOLTIPS.TOOLTIP_ANCHOR.Content,
  count: {
    n: 2,
    m: 2
  }
}, {
  id: '4',
  icon: 'icon_bracketfixing-type-04',
  tooltip:"TT110", //APP_TOOLTIPS.TOOLTIP_ANCHOR.Content,
  count: {
    n: 2,
    m: 3
  }
}, {
  id: '5',
  icon: 'icon_bracketfixing-type-05',
  tooltip:"TT110", //APP_TOOLTIPS.TOOLTIP_ANCHOR.Content,
  count: {
    n: 2,
    m: 4
  }
}, {
  id: '6',
  icon: 'icon_bracketfixing-type-n',
  tooltip:"TT111", //APP_TOOLTIPS.TOOLTIP_CUSTOMISE_ANCHOR.Content,
  withInput: true
}];



// WEBPACK FOOTER //
// ./src/reducers/selectors/application/initialState-bracket-attachment.js